import React, { useState } from 'react';
import {
  Card,
  Container,
  Stack,
  Typography,
  Tooltip,
  IconButton,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses
} from '@mui/material';
import { Box, styled } from '@mui/system';
import { BiCloudDownload } from 'react-icons/bi';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import Scrollbar from '../../components/Scrollbar';

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fafbfc'
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '8px 10px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: '#13519d',
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: '8px 10px',
    borderBottom: '1px solid #f1f5f9'
  }
}));

function InvoiceGeneratePayable() {
  return (
    <Page title="Partner Management System || Invoice">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
            sx={{ mb: 3 }}
          >
            <PageTitle info="Invoice Details" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Card
            sx={{
              p: 3.5,
              borderRadius: '16px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
              border: '1px solid #e2e8f0'
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
              <Tooltip title="Download Invoice" placement="top" arrow>
                <IconButton
                  sx={{
                    bgcolor: '#fff',
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    color: '#13519d',
                    p: 1,
                    '&:hover': {
                      bgcolor: 'rgba(19, 81, 157, 0.08)',
                      borderColor: '#13519d'
                    }
                  }}
                >
                  <BiCloudDownload size={18} />
                </IconButton>
              </Tooltip>
            </Box>

            <Typography
              variant="h5"
              sx={{ textAlign: 'center', mb: 3, fontWeight: 700, color: '#13519d' }}
            >
              Tax Invoice
            </Typography>

            <Grid container spacing={3} mb={3}>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    p: 2.5,
                    borderRadius: '12px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    height: '100%'
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1e293b', mb: 1 }}>
                    Kalolytic Solutions Pvt Ltd
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', mb: 0.5 }}>
                    A-605, Lancelot Bldg, 6th Floor, Opp Kalyan Jewellers, S V Road, Borivali West -
                    400 092
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', mb: 0.5 }}>
                    Contact No: 9820143480
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    Email: prasad_fortune@yahoo.co.in
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    overflow: 'hidden',
                    height: '100%'
                  }}
                >
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            Date
                          </StyledTableCell>
                          <StyledTableCell sx={{ fontWeight: 700, color: '#1e293b' }}>
                            9th Nov. 2021
                          </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            Invoice No
                          </StyledTableCell>
                          <StyledTableCell sx={{ fontWeight: 700, color: '#13519d' }}>
                            KSPL/2122/009
                          </StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            DSA Code
                          </StyledTableCell>
                          <StyledTableCell>DAA42100134</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            PAN No
                          </StyledTableCell>
                          <StyledTableCell>AAFCR7597F</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            GST No
                          </StyledTableCell>
                          <StyledTableCell>27AAFCR7597F1ZU</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            HSN Code
                          </StyledTableCell>
                          <StyledTableCell />
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    p: 2.5,
                    borderRadius: '12px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    height: '100%'
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#13519d', mb: 1 }}>
                    Bill To
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#1e293b', mb: 0.5 }}>
                    Kotak Mahindra Bank Limited
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', mb: 0.5 }}>
                    Address: Rajkot, Gujarat
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b' }}>
                    GST No: 24AAACK4409J1ZQ
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    overflow: 'hidden',
                    height: '100%'
                  }}
                >
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            GST Number
                          </StyledTableCell>
                          <StyledTableCell>AHRGF12346569799CS</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            Place of Supply
                          </StyledTableCell>
                          <StyledTableCell>Delhi</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            Branch Code
                          </StyledTableCell>
                          <StyledTableCell>RVL54233</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            State Code
                          </StyledTableCell>
                          <StyledTableCell>011</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            Disbursal Month
                          </StyledTableCell>
                          <StyledTableCell>June</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            Reverse Charges
                          </StyledTableCell>
                          <StyledTableCell>5,899</StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
            </Grid>

            {/* Line Items Table */}
            <Box
              sx={{
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                overflow: 'hidden',
                mb: 3
              }}
            >
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Name of Borrower</StyledTableCell>
                      <StyledTableCell>Product</StyledTableCell>
                      <StyledTableCell>Reference Number</StyledTableCell>
                      <StyledTableCell>Disbursal Amt</StyledTableCell>
                      <StyledTableCell>Payout %</StyledTableCell>
                      <StyledTableCell>DSA Payout Amt</StyledTableCell>
                      <StyledTableCell>CGST (9%)</StyledTableCell>
                      <StyledTableCell>SGST (9%)</StyledTableCell>
                      <StyledTableCell>IGST (18%)</StyledTableCell>
                      <StyledTableCell>Final Amt</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell colSpan={3}>
                        <Typography sx={{ fontWeight: 700, color: '#1e293b' }}>Total</Typography>
                      </StyledTableCell>
                      <StyledTableCell>-</StyledTableCell>
                      <StyledTableCell>-</StyledTableCell>
                      <StyledTableCell>-</StyledTableCell>
                      <StyledTableCell>-</StyledTableCell>
                      <StyledTableCell>-</StyledTableCell>
                      <StyledTableCell>-</StyledTableCell>
                      <StyledTableCell sx={{ fontWeight: 700, color: '#13519d' }}>
                        -
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* Bank details & Signatory */}
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0',
                    overflow: 'hidden'
                  }}
                >
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <StyledTableCell colSpan={2} sx={{ textAlign: 'center', py: 1 }}>
                            Bank Details (Kalolytic Solutions Pvt Ltd)
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            Bank Name & Branch
                          </StyledTableCell>
                          <StyledTableCell>-</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            Account No.
                          </StyledTableCell>
                          <StyledTableCell>-</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                          <StyledTableCell sx={{ fontWeight: 600, color: '#64748b' }}>
                            IFSC Code
                          </StyledTableCell>
                          <StyledTableCell>-</StyledTableCell>
                        </StyledTableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Grid>
              <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#475569' }}>
                  Authorized Signatory
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Container>
    </Page>
  );
}

export default InvoiceGeneratePayable;
